import { getMonthWiseDeals } from "http/UAM/userDashboardWidget.helper";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Card, CardBody } from "reactstrap";
import PropTypes from 'prop-types';
import NoDataChart from "pages/EntityMoreInformation/NoDataComponent";

const MonthlyDealsCreated = ({ userType }) => {
    const [dealsData, setDealsData] = useState([]);
    const [filter, setFilter] = useState('Count')
    const [showStatus, setShowStatus] = useState(true)

    const handleFilterChange = (e) => {
        setFilter(e.target.value);
    };

    const currencyShotern = (amount) => {
        if (amount && !isNaN(amount) && amount != undefined) {
            const formatter = new Intl.NumberFormat("en-IN", {
                style: "currency",
                currency: "INR",
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
                notation: "compact",
                compactDisplay: "long",
            });
            return formatter.format(amount);
        } else return "0.00";
    };

    useEffect(() => {
        getMonthWiseDeals({ type: filter }).then((res) => {
            const allDealCountsAreZero = res.data.some(item => item.dealCount != '0');
            setShowStatus(allDealCountsAreZero)
            setDealsData(res.data);
        });
    }, [filter, userType]);
    const options = {
        chart: {
            type: "area",
            height: 350,
            toolbar: {
                show: false,
            },
            zoom: {
                enabled: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "smooth",
            width: 3,
        },
        xaxis: {
            categories: dealsData.map((data) => data.monthYear),
            labels: {
                style: {
                    colors: "#333",
                },
            },
        },
        yaxis: {
            title: {
                text: 'Deals'
            },
            labels: {
                formatter: (val) => {
                    if (filter !== "count") {
                        return currencyShotern(val);
                    } else {
                        return val;
                    }
                },
                style: {
                    colors: "#333",
                },
            },
        },
        colors: [
            function ({ dataPointIndex }) {
                switch (dataPointIndex) {
                    case 0:
                        return "#00c5dc";
                    case 1:
                        return "#f46a6a";
                    case 2:
                        return "#34c38f";
                    case 3:
                        return "#3f9ae5";
                    case 4:
                        return "#f1b44c";
                    default:
                        return "#0174BE";
                }
            },
        ],

        fill: {
            type: "gradient",
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 90, 100],
            },
        },
        tooltip: {
            x: { show: false },
        },

    };

    const series = [
        {
            name: "Deals Created",
            data: dealsData.map((data) => parseInt(data.dealCount)),
        },
    ];
    return (
        <Card>
            {showStatus ? <CardBody>
                <h4 className="card-title mb-2">Monthwise Deals</h4>
                <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }} className="mb-2">
                    <select
                        style={{ width: '30%' }}
                        className="form-select"
                        id="filterOptions"
                        value={filter}
                        onChange={handleFilterChange}
                    >
                        <option value="count">Count</option>
                        <option value="amount">Amount (INR)</option>
                    </select>
                </div>
                <div id="vertical-bar-chart-top-financiers">
                    <ReactApexChart
                        options={options}
                        series={series}
                        type="area"
                        height={270}
                    />
                </div>
            </CardBody>
                : <NoDataChart title='No Information Found' subtitle="We couldn't find the Deal Created" />}
        </Card>
    );
};

MonthlyDealsCreated.propTypes = {
    userType: PropTypes.string.isRequired,
}

export default MonthlyDealsCreated;
